/**
 * Jenkins build fails when trying to access the @zillow registry
 * This is a copy of the onetrust-cookie-parser
 *
 * https://bitbucket.zgtools.net/projects/NPM/repos/onetrust-cookie-parser/browse
 */
import cookies from 'browser-cookies';

const ADVERTISING_COOKIE_KEY = '4';
const FUNCTIONAL_COOKIE_KEY = '3';

// To be returned in case of any trouble parsing the OptanonConsent Cookie
export const defaultCookiePreferences = {
  isFunctionalCookieBlocked: false,
  isAdvertisingCookieBlocked: false,
};

function parseOptanonCookie(optanonCookie: string | null) {
  const optanonConsent: Record<string, unknown> = {};
  if (optanonCookie !== null) {
    const groupStringArray = optanonCookie.split('&').filter((element: string) => element.includes('groups='));
    if (groupStringArray.length > 0) {
      const groupSplit = groupStringArray[0].substring(groupStringArray[0].indexOf('='));
      groupSplit.split(',').forEach((element: string) => {
        if (element.split(':').length > 1) {
          const [key, val] = element.split(':');
          optanonConsent[key] = val;
        }
      });
    }
  }
  return optanonConsent;
}

export function getUserCookiePreferences() {
  const optanonConsentCookie = cookies.get('OptanonConsent');
  const optanonConsent = parseOptanonCookie(optanonConsentCookie);
  const cookiePreferences = defaultCookiePreferences;
  if (Object.keys(optanonConsent).length !== 0) {
    if (optanonConsent[FUNCTIONAL_COOKIE_KEY] !== undefined) {
      cookiePreferences.isFunctionalCookieBlocked = optanonConsent[FUNCTIONAL_COOKIE_KEY] === '0';
    }
    if (optanonConsent[ADVERTISING_COOKIE_KEY] !== undefined) {
      cookiePreferences.isAdvertisingCookieBlocked = optanonConsent[ADVERTISING_COOKIE_KEY] === '0';
    }
  }
  return cookiePreferences;
}
